<ng-container [formGroup]="parent">
  <ng-container formGroupName="detail">
    <h3 class="mb-2">Details</h3>
    <div class="row">
      <div class="d-flex align-items-center mb-3 col-5">
        <div class="form-group has-float-label flex-grow-1">
          <label class="form-label">Ship date</label>
          <p-datePicker
            jniAutoCompleteBlocker
            inputId="basic"
            class="date-input"
            formControlName="shipDate"
            (onSelect)="onShipDateSelection($event)"
            [minDate]="shipDateCurrentdate"
            [ngClass]="{ 'has-error': formErrors['shipDate'] }"
            (onBlur)="logValidationErrors()"
            [showOtherMonths]="true"
            [selectOtherMonths]="true"></p-datePicker>

          <span class="error-msg" *ngIf="formErrors['shipDate']">
            {{ formErrors["shipDate"] }}
          </span>
        </div>
      </div>
      <div class="d-flex align-items-center mb-3 col-5">
        <div class="form-group has-float-label flex-grow-1">
          <label class="form-label"
            >In-hands date<span *ngIf="!templateService" class="madatory-field"
              >*</span
            ></label
          >
          <p-datePicker
            jniAutoCompleteBlocker
            inputId="basic"
            class="date-input"
            (onSelect)="onInHandDateSelection($event)"
            formControlName="inHandDate"
            [minDate]="inHandDateCurrentdate"
            [ngClass]="{ 'has-error': formErrors['inHandDate'] }"
            (onBlur)="logValidationErrors()"
            [showOtherMonths]="true"
            [selectOtherMonths]="true"></p-datePicker>

          <span class="error-msg" *ngIf="formErrors['inHandDate']">
            {{ formErrors["inHandDate"] }}
          </span>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group switcher">
          <label class="form-label d-block l-height mb-1 mt-2">Firm</label>
          <div
            class="form-check form-switch d-flex align-items-center m-0 gap-1">
            <p-toggleswitch
              id="flexSwitchCheckDefault"
              name="flexSwitchCheckDefault"
              formControlName="firm" />
            <label class="form-check-label" for="flexSwitchCheckDefault">
              {{ this.parent.get(["detail", "firm"])?.value }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group has-float-label mb-3 col-6">
        <label class="form-label">Shipping Method</label>
        <p-select
          id="currency"
          formControlName="shippingMethod"
          (onClear)="clearShippingMethod()"
          (onChange)="onShippingMethodSelect($event)"
          [options]="shippingProductsList"
          optionLabel="modeDescriptionD365"
          optionValue="modeCodeD365"
          [filter]="true"
          [showClear]="true">
        </p-select>
      </div>
      <div class="form-group has-float-label mb-3 col-6">
        <label class="form-label">Account #</label>
        <input
          pInputText
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          formControlName="accountNumberD365"
          (focusout)="applyAccountLengthValidation($event)" />
      </div>
    </div>
  </ng-container>
</ng-container>
